function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M406.8,235.4c17.4-21.3,28.1-47.2,30.8-74.5C446.1,73.8,377.7,0.1,292.5,0.1H64.7c-10.1,0-18.3,8.2-18.3,18.3v54.8 c0,10.1,8.2,18.3,18.3,18.3h36.4v329.1H64.7c-10.1,0-18.3,8.2-18.3,18.3v54.8c0,10.1,8.2,18.3,18.3,18.3h239.1 c80.9,0,153.2-59.2,161.1-139.8C470.3,316.7,446.2,266.9,406.8,235.4z M192.2,91.5h100.3c30.3,0,54.8,24.6,54.8,54.8 s-24.6,54.8-54.8,54.8H192.2L192.2,91.5L192.2,91.5z M292.5,420.5H192.2v-128h100.3c35.4,0,63.9,28.7,63.9,63.9 S327.8,420.5,292.5,420.5z"
});

function SvgBold(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBold);
export default __webpack_public_path__ + "static/media/bold.25f283e2.svg";
export { ForwardRef as ReactComponent };